/* eslint-disable tailwindcss/no-custom-classname */
import React, { useEffect } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import './error.style.scss';

export const BrowseSearchErrorB2B = () => {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('default-4xx.load-plp', {});
    }
  }, []);

  return (
    <div className="error-b2b" data-testid="b2b-messaging">
      <div className="error-b2b__container">
        <p className="error-b2b__title">We&#39;re sorry, the product you&#39;re searching for is not available.</p>
        <div className="error-b2b__description">
          <p>If you have any questions, reach out to the customer support team.</p>
          <p>Phone: 1-800-525-5000</p>
          <p>Email:
            <a className="error-b2b__mail-link" href="mailto: customercare@homedepot.com">
              customercare@homedepot.com
            </a>
          </p>
        </div>
        <div className="error-b2b__buttons">
          <Button tag="a" inline onClick={() => { }} href="https://www.homedepot.com">
            Back to Homepage
          </Button>
        </div>
        {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
        <img
          src="https://assets.homedepot-static.com/images/v1/HD-bucket-cropped.png"
          className="error-b2b__image"
          alt="error page"
        />
      </div>
    </div>
  );
};

BrowseSearchErrorB2B.displayName = 'BrowseSearchErrorB2B';